import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import Icon from 'dpl/common/components/Icon';
import { sendRudderstackEvent } from 'dpl/util/analytics';
import {
  ANALYTICS_EVENTS,
  ANALYTICS_VIEW_FEATURE_LOCATIONS,
  ANALYTICS_VIEW_FEATURES,
  ANALYTICS_VIEWS
} from 'dpl/constants/analytics';
import { TAB_KEYS } from 'dpl/components/BreederProfile/utils/constants';
import { FILTER_LOCATION_NAME } from 'dpl/constants/query_params';

import { getBreederProfileUrl } from '../mobile/components/Card';

export default function CardFooter({
  availabilityDescription,
  testimonialsCount,
  breederResponseDescription,
  url
}) {
  const locName = useSelector(
    ({ queryParams }) => queryParams[FILTER_LOCATION_NAME]
  );

  const hasVerifiedStories = testimonialsCount > 0;

  if (
    !availabilityDescription &&
    !hasVerifiedStories &&
    !breederResponseDescription
  ) {
    return null;
  }

  const breederReviewsUrl = getBreederProfileUrl(url, {
    tab: TAB_KEYS.STORIES,
    locName
  });

  function handleReviewsClick(e) {
    e.preventDefault();
    e.stopPropagation();

    sendRudderstackEvent(ANALYTICS_EVENTS.BUTTON_CLICKED, {
      button_cta: 'breeder_reviews',
      view: ANALYTICS_VIEWS.BREEDER_SEARCH_RESULTS,
      view_feature: ANALYTICS_VIEW_FEATURES.BREEDER_REVIEWS_LINK,
      view_feature_location: ANALYTICS_VIEW_FEATURE_LOCATIONS.SEARCH_RESULTS
    });

    window.location.href = breederReviewsUrl;
  }

  const showResponseDescription =
    !availabilityDescription &&
    !hasVerifiedStories &&
    breederResponseDescription;

  return (
    <div className="BreederSearchResultsCardFooter mh4 pv4 items-center bt b--default">
      <div className="flex items-center justify-between font-16">
        {availabilityDescription && (
          <p className="fw-medium">{availabilityDescription}</p>
        )}

        {hasVerifiedStories && (
          <div className="flex items-center gap-8" title="Verified stories">
            <Icon
              className="secondary"
              name="fetch-check"
              height="20px"
              width="20px"
            />
            <button
              type="button"
              className="secondary underline lh-body"
              onClick={handleReviewsClick}
            >
              {testimonialsCount} {testimonialsCount > 1 ? 'reviews' : 'review'}
            </button>
          </div>
        )}

        {showResponseDescription && (
          <div className="flex items-center gap-8">
            <Icon
              className="secondary"
              name="fetch-message"
              height="20px"
              width="20px"
            />
            <p className="secondary">{breederResponseDescription}</p>
          </div>
        )}
      </div>
    </div>
  );
}

CardFooter.propTypes = {
  availabilityDescription: PropTypes.string,
  testimonialsCount: PropTypes.number,
  breederResponseDescription: PropTypes.string,
  url: PropTypes.string.isRequired
};

CardFooter.defaultProps = {
  availabilityDescription: null,
  testimonialsCount: null,
  breederResponseDescription: null
};
